<template>
    <div>
        <Wp_nav_bar title="常见问题"></Wp_nav_bar>

        <div class="app-container">
            <mavon-editor ref="md" @save="save" @imgAdd="imgAdd" @imgDel="imgDel" v-model="markdownForm.contentMarkdown" :codeStyle="markdown.codeStyle" :toolbars="markdown.toolbars"   />

        </div>
    </div>
</template>

<script>
    // import {getMarkdownArticle} from ''
    import {getMarkdownArticle,saveMarkdownArticle} from 'mavon-editor';
    import {uploadImg} from 'mavon-editor'
    import Wp_nav_bar from "../custom/Wp_nav_bar";

    export default {
        name: "Wp_jd_qa",
        components: {Wp_nav_bar},
        data(){
            return{
                value: 'https://jd.wapg.cn/help/京东内购群常见问题解答/一、什么是京东内购，优惠券从哪里来？.md',

                markdown:{
                    codeStyle:'atom-one-dark',
                    toolbars:{
                        bold: true, // 粗体
                        italic: true, // 斜体
                        header: true, // 标题
                        underline: true, // 下划线
                        strikethrough: true, // 中划线
                        mark: true, // 标记
                        superscript: true, // 上角标
                        subscript: true, // 下角标
                        quote: true, // 引用
                        ol: true, // 有序列表
                        ul: true, // 无序列表
                        link: true, // 链接
                        imagelink: true, // 图片链接
                        code: true, // code
                        table: true, // 表格
                        fullscreen: true, // 全屏编辑
                        readmodel: true, // 沉浸式阅读
                        htmlcode: true, // 展示html源码
                        help: true, // 帮助
                        /* 1.3.5 */
                        undo: true, // 上一步
                        redo: true, // 下一步
                        trash: true, // 清空
                        save: true, // 保存（触发events中的save事件）
                        /* 1.4.2 */
                        navigation: true, // 导航目录
                        /* 2.1.8 */
                        alignleft: true, // 左对齐
                        aligncenter: true, // 居中
                        alignright: true, // 右对齐
                        /* 2.2.1 */
                        subfield: true, // 单双栏模式
                        preview: false, // 预览
                    }
                },
                markdownForm : {
                    articleId:null,
                    title:"",
                    contentMarkdown:'',
                    contentHtml:null,
                    type:0
                },
                rules: {
                    title: [
                        { required: true, message: '请输入标题', trigger: 'blur' },
                        { min: 1, max: 80, message: '长度在1到80个字符', trigger: 'blur' }
                    ]
                },
                lastSaveTime:null,
                timer:null
            }
        },

        created(){
            this.getArticle()
        },
        mounted() {
            this.timer = setInterval(this.intervalSave, 2*60*1000);
        },
        beforeDestroy() {
            clearInterval(this.timer);
        },

        methods:{
            getArticle(){  //获取文章内容
                let id=this.$route.query.a
                if(id==null){
                    this.markdownForm.contentMarkdown=''
                }else{

                    getMarkdownArticle(id).then(r => {
                        this.markdownForm.contentMarkdown=r.data.contentMarkdown==null?'':r.data.contentMarkdown
                        this.markdownForm.articleId=r.data.articleId
                        this.markdownForm.title=r.data.title
                        this.markdownForm.type=r.data.type
                    }).catch(e => {
                        this.$log(e)
                    })
                }
            },
            save(){  //保存文章内容
                saveMarkdownArticle(this.markdownForm).then(r => {
                    this.$message.success("保存成功")
                    this.markdownForm.articleId=r.data.articleId
                    this.lastSaveTime=new Date()
                }).catch(e => {
                    this.$log(e)
                })
            },
            intervalSave(){ //自动保存
                let now = new Date()
                if(now-this.lastSaveTime>=2*60*1000){
                    saveMarkdownArticle(this.markdownForm).then(r => {
                        this.$message.success("自动保存成功")
                        this.lastSaveTime=new Date()
                    }).catch(e => {
                        this.$log(e)
                    })
                }
            },
            imgAdd(pos, file){ //添加图片，pos为位置
                let markdownImg = {},$vm=this.$refs.md
                markdownImg.base64Data=file.miniurl
                markdownImg.type=file.type
                uploadImg(markdownImg).then(r => {
                    this.$log(r)
                    $vm.$img2Url(pos,process.env.VUE_APP_BASE_API+'/img/'+r.data)
                }).catch(e => {
                    this.$log(e)
                })
            },
            imgDel(pos,url){ //删除图片，并不是修改就会触发，仅支持工具栏操作
                this.$log(pos)
                this.$log(url)
            },
        }
    }
</script>

<style scoped>

</style>